export default "__VITE_ASSET__73b68054__"